import { api } from '../../../api/axios'
import type { Usuario, Role, Permissao, UsuarioFilters, RoleFilters, ListResponse } from '../types'

export const usuariosService = {
  list: (filters: UsuarioFilters = {}) =>
    api.get<ListResponse<Usuario>>('/usuarios', { params: filters }).then(r => r.data),

  getById: (id: number) =>
    api.get<{ data: Usuario }>(`/usuarios/${id}`).then(r => r.data.data),

  create: (data: { nome: string; email: string; senha: string; ativo?: boolean; roles?: string[] }) =>
    api.post<{ data: Usuario }>('/usuarios', data).then(r => r.data.data),

  update: (id: number, data: Partial<{ nome: string; email: string; senha: string; ativo: boolean; roles: string[] }>) =>
    api.put<{ data: Usuario }>(`/usuarios/${id}`, data).then(r => r.data.data),

  delete: (id: number) =>
    api.delete(`/usuarios/${id}`),
}

export const rolesService = {
  list: (filters: RoleFilters = {}) =>
    api.get<ListResponse<Role>>('/roles', { params: filters }).then(r => r.data),

  getById: (id: number) =>
    api.get<{ data: Role }>(`/roles/${id}`).then(r => r.data.data),

  create: (data: { nome: string; descricao?: string; ativo?: boolean; permissoes?: number[] }) =>
    api.post<{ data: Role }>('/roles', data).then(r => r.data.data),

  update: (id: number, data: Partial<{ nome: string; descricao: string; ativo: boolean; permissoes: number[] }>) =>
    api.put<{ data: Role }>(`/roles/${id}`, data).then(r => r.data.data),

  delete: (id: number) =>
    api.delete(`/roles/${id}`),
}

export const permissoesService = {
  list: (filters: { recurso?: string; page?: number; limit?: number } = {}) =>
    api.get<ListResponse<Permissao>>('/permissoes', { params: { limit: 200, ...filters } }).then(r => r.data),
}
